(function($) {
  'use strict';

  // Cast & Crew Component-based Manager
  const CastCrewComponents = {
    // Configuration
    config: {
      titleId: null,
      apiKey: null,
      apiSecret: null,
      baseUrl: null,
      data: [],
      filteredData: [],
      unsavedChanges: new Set(),
      invalidRows: new Set(),
      initialized: false, // Prevent double initialization
      roleMap: {
        2: 'actor',
        3: 'director',
        7: 'writer',
        8: 'producer',
      },
      reverseRoleMap: {
        'actor': 2,
        'director': 3,
        'writer': 7,
        'producer': 8,
      },
    },

    // Initialize the module
    init: function() {
      // Prevent double initialization
      if (this.config.initialized) {
        console.log('CastCrewComponents already initialized');
        return;
      }

      // Set up configuration
      this.config.titleId = window.sflow?.title?.id;
      this.config.apiKey = window.sflow?.api?.key;
      this.config.apiSecret = window.sflow?.api?.secret;
      this.config.baseUrl = window.sflow?.api?.baseUrl || '';

      if (!this.config.titleId) {
        console.error('No title ID provided');
        return;
      }

      // Mark as initialized
      this.config.initialized = true;

      // Initialize Foundation
      $(document).foundation();

      // Load data
      this.loadData();

      // Bind events
      this.bindEvents();

      // Setup navigation guard
      this.setupNavigationGuard();
    },

    // Load cast & crew data
    loadData: function() {
      const self = this;

      this.apiRequest('GET', `titles/${this.config.titleId}/contacts`)
        .then(result => {
          if (result.success && result.data && result.data.contacts) {
            // Sort by display_order initially
            self.config.data = result.data.contacts.sort((a, b) =>
              (a.display_order || 0) - (b.display_order || 0),
            );

            // Mark existing contacts as matched
            self.config.data.forEach(item => {
              if (item.id) {
                item.matched = true;
              }
              // Validate each row
              self.validateRow(item);
            });

            self.config.filteredData = [...self.config.data];
            self.renderList();
            self.updateIndicators();
          }
        })
        .catch(error => {
          self.showError('Failed to load cast & crew data');
          console.error(error);
        });
    },

    // Render the list of components
    renderList: function(skipAnimation = false) {
      const container = $('#cast-crew-items');

      // Clean up any existing drag operations before re-rendering
      this.cleanupDragOperations();

      container.empty();

      // Add class to skip animations during reordering
      if (skipAnimation) {
        container.addClass('no-animation');
      } else {
        container.removeClass('no-animation');
      }

      if (this.config.filteredData.length === 0) {
        const searchTerm = $('#search-cast-crew').val().trim();
        const hasFilter = searchTerm.length > 0;

        container.html(`
                    <div class="empty-state">

                        <p>${hasFilter ? '' : 'No cast & crew members found'}</p>
                        ${hasFilter ?
    '<button class="btn btn-secondary btn-glass" onclick="CastCrewComponents.clearSearch()"><i class="fas fa-times"></i> No results found</button>' :
    ''}
                    </div>
                `);
        return;
      }

      // Add column headers
      const headersHtml = `
        <div class="cast-crew-headers">
          <div class="header-drag-handle"></div>
          <div class="header-avatar"></div>
          <div class="header-details">
            <div class="header-name">Name</div>
            <div class="header-character">Character</div>
          </div>
          <div class="header-roles">Roles</div>
          <div class="header-actions">Actions</div>
        </div>
      `;
      container.append(headersHtml);

      // Render each person component
      this.config.filteredData.forEach((person, index) => {
        container.append(this.createPersonComponent(person, index));
      });

      // Initialize drag and drop
      this.initializeDragAndDrop();
    },

    // Create a person component
    createPersonComponent: function(person, index) {
      const hasChanges = this.config.unsavedChanges.has(person.title_contact_id);
      const roles = this.getRolesForPerson(person);
      const isActor = roles.includes('actor');
      const isInvalid = this.config.invalidRows.has(person.title_contact_id);
      const isDeleted = person.deleted || false;
      const isNew = person.title_contact_id.toString().startsWith('new_') || person.isNew;
      const hasImdbId = person.c_imdb_id || false;

      // Check if this is Shaked Berenson
      const isShakedBerenson = person.name && person.name.toLowerCase().includes('shaked berenson');
      const sparklerClass = isShakedBerenson ? 'sparkler-effect' : '';

      const avatarHtml = person.c_avatar ?
        `<div class="person-avatar ${sparklerClass}">
            <img src="${person.c_avatar}" alt="${person.name || 'Person'}" onerror="this.style.display='none'">
        </div>` :
        `<div class="person-avatar person-avatar-placeholder ${sparklerClass}">
            <i class="fas fa-user"></i>
        </div>`;

      // Determine which class to apply (priority order)
      let statusClass = '';
      if (isDeleted) {
        statusClass = 'deleted';
      } else if (isInvalid) {
        statusClass = 'invalid';
      } else if (isNew) {
        statusClass = 'newly-added';
      } else if (hasChanges) {
        statusClass = 'has-changes';
      }

      return $(`
                <div class="person-component ${statusClass}"
                     data-id="${person.title_contact_id}"
                     data-index="${index}">
                    <div class="drag-handle">
                        <i class="fas fa-grip-vertical"></i>
                    </div>

                    ${avatarHtml}

                    <div class="person-details">
                        ${person.matched || person.contact_id || person.id ?
    `<div class="matched-indicator" title="Matched to existing contact">
                            ${person.contact_id || person.id ?
    `<a href="/contact-person-edit?action=edit&id=${person.contact_id || person.id}"
                                  class="matched-edit-link"
                                  title="Matched existing contact"
                                  target="_blank">
                                <i class="fas fa-check-circle"></i>
                              </a>` :
    '<i class="fas fa-check-circle"></i>'
  }
                          </div>` : ''}
                        ${isNew && !person.matched && !person.contact_id ? '<div class="new-contact-indicator" title="New contact will be created"><i class="fas fa-check-circle"></i></div>' : ''}
                        <div class="person-name">
                            <input type="text"
                                   id="name-${person.title_contact_id}"
                                   value="${person.name || ''}"
                                   placeholder="Name"
                                   autocomplete="off"
                                   style="margin-bottom: 0"
                                   data-field="name"
                                   data-id="${person.title_contact_id}"
                                   ${person.matched && !window.sflow?.permissions?.can_edit_contact ? 'readonly' : ''}
                                   ${person.matched && !window.sflow?.permissions?.can_edit_contact ? 'title="You do not have permission to edit contact names"' : ''}
                                   class="${person.matched && !window.sflow?.permissions?.can_edit_contact ? 'readonly-contact' : ''}">
                        </div>

                        <div class="person-character ${isActor ? '' : 'hidden'}">
                            <input type="text"
                                   id="character-${person.title_contact_id}"
                                   value="${person.contact_character_name || ''}"
                                   placeholder="Character name"
                                   style="margin-bottom: 0"
                                   data-field="contact_character_name"
                                   data-id="${person.title_contact_id}">
                        </div>
                    </div>

                    <div class="person-roles">
                        <div class="role-selection">
                            <div class="role-checkbox">
                                <input type="checkbox"
                                       id="actor-${person.title_contact_id}"
                                       class="role-actor"
                                       data-role="actor"
                                       data-id="${person.title_contact_id}"
                                       ${roles.includes('actor') ? 'checked' : ''}>
                                <label for="actor-${person.title_contact_id}">Actor</label>
                            </div>
                            <div class="role-checkbox">
                                <input type="checkbox"
                                       id="director-${person.title_contact_id}"
                                       class="role-director"
                                       data-role="director"
                                       data-id="${person.title_contact_id}"
                                       ${roles.includes('director') ? 'checked' : ''}>
                                <label for="director-${person.title_contact_id}">Director</label>
                            </div>
                            <div class="role-checkbox">
                                <input type="checkbox"
                                       id="producer-${person.title_contact_id}"
                                       class="role-producer"
                                       data-role="producer"
                                       data-id="${person.title_contact_id}"
                                       ${roles.includes('producer') ? 'checked' : ''}>
                                <label for="producer-${person.title_contact_id}">Producer</label>
                            </div>
                            <div class="role-checkbox">
                                <input type="checkbox"
                                       id="writer-${person.title_contact_id}"
                                       class="role-writer"
                                       data-role="writer"
                                       data-id="${person.title_contact_id}"
                                       ${roles.includes('writer') ? 'checked' : ''}>
                                <label for="writer-${person.title_contact_id}">Writer</label>
                            </div>
                        </div>
                    </div>

                    <div class="person-actions">
                        <div class="move-buttons">
                            <button type="button" class="btn-icon move-up"
                                    data-id="${person.title_contact_id}"
                                    title="Move up"
                                    ${index === 0 ? 'disabled' : ''}>
                                <i class="fas fa-chevron-up"></i>
                            </button>
                            <button type="button" class="btn-icon move-down"
                                    data-id="${person.title_contact_id}"
                                    title="Move down"
                                    ${index === this.config.filteredData.length - 1 ? 'disabled' : ''}>
                                <i class="fas fa-chevron-down"></i>
                            </button>
                        </div>
                        <button type="button" class="btn-icon delete-person"
                                data-id="${person.title_contact_id}"
                                title="Remove">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            `);
    },

    // Get roles for a person
    getRolesForPerson: function(person) {
      if (!Array.isArray(person.contact_types)) return [];

      return person.contact_types.map(roleId =>
        this.config.roleMap[roleId],
      ).filter(Boolean);
    },

    // Initialize drag and drop using HTML5 Drag and Drop API
    initializeDragAndDrop: function() {
      const self = this;
      const container = $('#cast-crew-items');
      let draggedElement = null;
      let draggedIndex = null;

      // Remove any existing event bindings
      container.off('.dragdrop');
      $(document).off('.dragdrop');

      // Make person components draggable
      container.on('mouseenter.dragdrop', '.person-component', function() {
        const $component = $(this);
        if (!$component.attr('draggable')) {
          $component.attr('draggable', 'true');
        }
      });

      // Drag start
      container.on('dragstart.dragdrop', '.person-component', function(e) {
        draggedElement = $(this);
        draggedIndex = draggedElement.index('.person-component');

        // Add dragging class for visual feedback
        draggedElement.addClass('dragging');

        // Store drag data
        e.originalEvent.dataTransfer.effectAllowed = 'move';
        e.originalEvent.dataTransfer.setData('text/html', this.innerHTML);

        // Create custom drag image with proper styling
        const rect = this.getBoundingClientRect();
        const dragImage = draggedElement.clone()[0];

        // Apply necessary styles to maintain appearance
        dragImage.style.position = 'absolute';
        dragImage.style.top = '-9999px';
        dragImage.style.left = '-9999px';
        dragImage.style.width = rect.width + 'px';
        dragImage.style.height = rect.height + 'px';
        dragImage.style.opacity = '0.9';
        dragImage.style.backgroundColor = 'white';
        dragImage.style.border = '1px solid #e5e7eb';
        dragImage.style.borderRadius = '8px';
        dragImage.style.padding = '8px 12px';
        dragImage.style.display = 'flex';
        dragImage.style.alignItems = 'center';
        dragImage.style.gap = '12px';
        dragImage.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';

        // Ensure drag image is added to container to inherit styles
        container.append(dragImage);

        // Set the drag image
        e.originalEvent.dataTransfer.setDragImage(dragImage, e.originalEvent.offsetX, e.originalEvent.offsetY);

        // Remove the drag image after a brief delay
        setTimeout(() => dragImage.remove(), 0);
      });

      // Drag over - allow drop
      container.on('dragover.dragdrop', '.person-component', function(e) {
        if (e.preventDefault) {
          e.preventDefault();
        }
        e.originalEvent.dataTransfer.dropEffect = 'move';

        const $this = $(this);
        const draggingOver = this !== draggedElement[0];

        if (draggingOver) {
          // Remove all existing drop indicators
          $('.drop-indicator').removeClass('drop-indicator-above drop-indicator-below');

          // Calculate if we're in the top or bottom half
          const rect = this.getBoundingClientRect();
          const midpoint = rect.top + rect.height / 2;
          const isAbove = e.originalEvent.clientY < midpoint;

          // Add appropriate indicator
          $this.addClass('drop-indicator');
          $this.addClass(isAbove ? 'drop-indicator-above' : 'drop-indicator-below');
        }

        return false;
      });

      // Drag enter
      container.on('dragenter.dragdrop', '.person-component', function(e) {
        $(this).addClass('drag-over');
      });

      // Drag leave
      container.on('dragleave.dragdrop', '.person-component', function(e) {
        $(this).removeClass('drag-over');
      });

      // Drop
      container.on('drop.dragdrop', '.person-component', function(e) {
        if (e.stopPropagation) {
          e.stopPropagation();
        }

        const $dropTarget = $(this);

        if (draggedElement && this !== draggedElement[0]) {
          // Calculate if we should insert before or after
          const rect = this.getBoundingClientRect();
          const midpoint = rect.top + rect.height / 2;
          const insertBefore = e.originalEvent.clientY < midpoint;

          // Perform the move
          if (insertBefore) {
            $dropTarget.before(draggedElement);
          } else {
            $dropTarget.after(draggedElement);
          }

          // Calculate new index and handle reorder
          const newIndex = draggedElement.index('.person-component');
          if (draggedIndex !== newIndex) {
            self.handleReorder(draggedIndex, newIndex);
          }
        }

        return false;
      });

      // Drag end - cleanup
      container.on('dragend.dragdrop', '.person-component', function(e) {
        // Remove all visual indicators
        $('.person-component').removeClass('dragging drag-over drop-indicator drop-indicator-above drop-indicator-below');

        // Reset variables
        draggedElement = null;
        draggedIndex = null;
      });

      // Touch support using mouse events as fallback
      let touchItem = null;
      let touchOffset = { x: 0, y: 0 };

      container.on('touchstart.dragdrop', '.drag-handle', function(e) {
        const touch = e.originalEvent.touches[0];
        touchItem = $(this).closest('.person-component');
        const rect = touchItem[0].getBoundingClientRect();

        touchOffset.x = touch.clientX - rect.left;
        touchOffset.y = touch.clientY - rect.top;

        touchItem.addClass('dragging');
      });

      $(document).on('touchmove.dragdrop', function(e) {
        if (!touchItem) return;

        e.preventDefault();
        const touch = e.originalEvent.touches[0];

        // Find element under touch point
        const elementBelow = document.elementFromPoint(touch.clientX, touch.clientY);
        if (elementBelow) {
          const $component = $(elementBelow).closest('.person-component');
          if ($component.length && $component[0] !== touchItem[0]) {
            const rect = $component[0].getBoundingClientRect();
            const midpoint = rect.top + rect.height / 2;

            if (touch.clientY < midpoint) {
              $component.before(touchItem);
            } else {
              $component.after(touchItem);
            }
          }
        }
      });

      $(document).on('touchend.dragdrop', function(e) {
        if (!touchItem) return;

        touchItem.removeClass('dragging');

        // Calculate final position and update
        const oldIndex = self.config.filteredData.findIndex(p =>
          p.title_contact_id === touchItem.data('id'),
        );
        const newIndex = container.find('.person-component').index(touchItem);

        if (oldIndex !== -1 && oldIndex !== newIndex) {
          self.handleReorder(oldIndex, newIndex);
        }

        touchItem = null;
      });
    },

    // Handle reordering
    handleReorder: function(oldIndex, newIndex) {
      if (oldIndex === newIndex) return;

      // Update the data array
      const [movedItem] = this.config.filteredData.splice(oldIndex, 1);
      this.config.filteredData.splice(newIndex, 0, movedItem);

      // Update display orders
      this.config.filteredData.forEach((item, index) => {
        const originalIndex = this.config.data.findIndex(d =>
          d.title_contact_id === item.title_contact_id,
        );
        if (originalIndex !== -1) {
          this.config.data[originalIndex].display_order = index;
          this.config.unsavedChanges.add(item.title_contact_id);
        }
      });

      // Update UI without re-rendering the entire list
      this.updateSaveButton();
      this.showUnsavedIndicator();

      // Only update move button states for affected items
      this.updateMoveButtons();
    },

    // Update move button states without re-rendering
    updateMoveButtons: function() {
      const $items = $('#cast-crew-items .person-component');
      const totalItems = $items.length;

      $items.each(function(index) {
        const $item = $(this);
        const $moveUp = $item.find('.move-up');
        const $moveDown = $item.find('.move-down');

        // Update data-index attribute
        $item.attr('data-index', index);

        // Update button states
        $moveUp.prop('disabled', index === 0);
        $moveDown.prop('disabled', index === totalItems - 1);
      });
    },

    // Bind events
    bindEvents: function() {
      const self = this;

      // Unbind existing events to prevent duplicates
      $('#add-cast-crew').off('click.castcrew');
      $('#delete-all-cast-crew').off('click.castcrew');
      $('#import-csv').off('click.castcrew');
      $('#import-imdb').off('click.castcrew');
      $('#search-cast-crew').off('input.castcrew');
      $('#clear-search').off('click.castcrew');
      $('#save-all, #save-all-bottom, #save-cast-crew').off('click.castcrew');
      $('#cast-crew-items').off('.castcrew');
      $(document).off('click.castcrew', '.save-multi.step2');
      $(document).off('click.castcrew', '.submit-multi.step2');

      // Add button
      $('#add-cast-crew').on('click.castcrew', () => this.addNewRow());

      // Delete all button
      $('#delete-all-cast-crew').on('click.castcrew', () => this.deleteAll());

      // Import buttons
      $('#import-csv').on('click.castcrew', () => this.openImportModal('csv'));
      $('#import-imdb').on('click.castcrew', () => this.openImportModal('imdb'));

      // Search
      $('#search-cast-crew').on('input.castcrew', (e) => this.handleSearch(e.target.value));

      // Clear search button
      $('#clear-search').on('click.castcrew', () => this.clearSearch());

      // Save all buttons (top, bottom, and integrated mode)
      $('#save-all, #save-all-bottom, #save-cast-crew').on('click.castcrew', () => {
        console.log('Save button clicked. Invalid rows:', this.config.invalidRows.size);

        // Check for invalid rows before saving (excluding deleted rows)
        const nonDeletedInvalidRows = Array.from(this.config.invalidRows).filter(id => {
          const person = this.config.data.find(d => d.title_contact_id === id);
          return person && !person.deleted;
        });

        if (nonDeletedInvalidRows.length > 0) {
          alert(`Cannot save: There are ${nonDeletedInvalidRows.length} invalid field${nonDeletedInvalidRows.length > 1 ? 's' : ''}. Please correct the highlighted rows (name and at least one role required).`);

          // Highlight non-deleted invalid rows
          nonDeletedInvalidRows.forEach(id => {
            const $component = $(`.person-component[data-id="${id}"]`);
            $component.addClass('invalid-highlight');
            setTimeout(() => $component.removeClass('invalid-highlight'), 800);
          });

          return;
        }

        this.saveAll();
      });

      // Hook into the title save button (step 2) to save cast/crew first
      $(document).on('click.castcrew', '.save-multi.step2', (e) => {
        if (this.config.unsavedChanges.size > 0) {
          // Check for invalid rows before saving (excluding deleted rows)
          const nonDeletedInvalidRows = Array.from(this.config.invalidRows).filter(id => {
            const person = this.config.data.find(d => d.title_contact_id === id);
            return person && !person.deleted;
          });

          if (nonDeletedInvalidRows.length > 0) {
            e.stopImmediatePropagation();
            $('.loady-save-multi.step2').hide();

            alert(`Cannot save: There are ${nonDeletedInvalidRows.length} invalid Cast & Crew field${nonDeletedInvalidRows.length > 1 ? 's' : ''}. Please correct the highlighted rows.`);

            // Highlight non-deleted invalid rows
            nonDeletedInvalidRows.forEach(id => {
              const $component = $(`.person-component[data-id="${id}"]`);
              $component.addClass('invalid-highlight');
              setTimeout(() => $component.removeClass('invalid-highlight'), 800);
            });

            return;
          }

          // Prevent the default title save
          e.stopImmediatePropagation();

          // Show loading state
          $('.loady-save-multi.step2').show();

          // Save cast & crew first
          this.saveAll()
            .then(() => {
              // Cast & crew saved, now let the title save proceed
              $(document).off('click.castcrew', '.save-multi.step2');
              $('.save-multi.step2').trigger('click');

              // Re-attach handler after a delay
              setTimeout(() => {
                this.bindEvents();
              }, 1000);
            })
            .catch(error => {
              console.error('Failed to save cast & crew:', error);
              $('.loady-save-multi.step2').hide();
              alert('Failed to save cast & crew changes. Please try again.');
            });
        }
      });

      // Hook into the NEXT button (step 2) to warn about unsaved changes
      $(document).on('click.castcrew', '.submit-multi.step2', (e) => {
        if (this.config.unsavedChanges.size > 0) {
          // Prevent navigation
          e.stopImmediatePropagation();

          // Show confirmation dialog
          const message = `You have unsaved cast & crew changes. Do you want to save them before continuing?\n\n` +
            `Click OK to save and continue\n` +
            `Click Cancel to stay on this page`;

          if (confirm(message)) {
            // User wants to save first
            $('.loady-multi.step2').show();

            // Save cast & crew first
            this.saveAll()
              .then(() => {
                // Cast & crew saved, now trigger the navigation
                $(document).off('click.castcrew', '.submit-multi.step2');
                $('.submit-multi.step2').trigger('click');

                // Re-attach handler after a delay
                setTimeout(() => {
                  this.bindEvents();
                }, 1000);
              })
              .catch(error => {
                console.error('Failed to save cast & crew:', error);
                $('.loady-multi.step2').hide();
                alert('Failed to save cast & crew changes. Please try again.');
              });
          }
          // If user clicks Cancel, do nothing (stay on page)
        }
      });

      // Delegated events for dynamic elements
      $('#cast-crew-items')
        .on('input.castcrew', 'input[data-field]', (e) => this.handleFieldChange(e))
        .on('focus.castcrew click.castcrew', 'input[data-field="name"]', (e) => this.handleNameFieldFocus(e))
        .on('change.castcrew', '.person-roles input[type="checkbox"]', (e) => this.handleRoleToggle(e))
        .on('click.castcrew', '.delete-person', (e) => this.deletePerson($(e.currentTarget).data('id')))
        .on('click.castcrew', '.move-up', (e) => this.movePerson($(e.currentTarget).data('id'), -1))
        .on('click.castcrew', '.move-down', (e) => this.movePerson($(e.currentTarget).data('id'), 1));

      // Removed modal-related event handlers as there's no modal in the implementation
    },

    // Handle field changes
    handleFieldChange: function(e) {
      const $input = $(e.target);
      const id = $input.data('id');
      const field = $input.data('field');
      const value = $input.val();

      // Update data
      const item = this.config.data.find(d => d.title_contact_id === id);
      if (item) {
        item[field] = value;
        this.config.unsavedChanges.add(id);

        // If name field changed, trigger auto-suggest
        if (field === 'name') {
          this.setupAutoSuggest($input);
        }

        // Validate and update UI
        this.validateRow(item);
        this.updatePersonComponent(id);
        this.updateSaveButton();
        this.updateIndicators();
      }
    },

    // Handle focus/click on name field to show autocomplete
    handleNameFieldFocus: function(e) {
      const $input = $(e.target);
      const id = $input.data('id');
      const value = $input.val().trim();

      // If field has value, trigger autocomplete
      if (value.length >= 2) {
        this.setupAutoSuggest($input);
      }
    },

    // Setup auto-suggest for name fields
    setupAutoSuggest: function($input) {
      const self = this;
      const id = $input.data('id');

      // Remove any existing autocomplete
      if ($input.data('autocomplete-timeout')) {
        clearTimeout($input.data('autocomplete-timeout'));
      }

      // Debounce the search
      const timeout = setTimeout(() => {
        const query = $input.val().trim();
        if (query.length >= 2) {
          // Show loading indicator
          this.showAutoSuggestLoading($input);

          this.searchContacts(query, (suggestions) => {
            this.showAutoSuggest($input, suggestions, id);
          });
        } else {
          this.hideAutoSuggest();
        }
      }, 300);

      $input.data('autocomplete-timeout', timeout);
    },

    // Search contacts for auto-suggest
    searchContacts: function(query, callback) {
      // Check if query is a numeric ID
      const isNumericId = /^\d+$/.test(query.trim());

      // If it's a numeric ID, search by both ID and name
      let apiUrl = `contacts/suggest?q=${encodeURIComponent(query)}&limit=10`;
      if (isNumericId) {
        // Include ID search parameter when query is numeric
        apiUrl += `&id=${query}`;
      }

      this.apiRequest('GET', apiUrl)
        .then(result => {
          if (result.success && result.data) {
            // Sort results to prioritize:
            // 1. Exact ID matches (if searching by ID)
            // 2. Users with IMDB IDs
            // 3. Users with avatars
            const sortedResults = result.data.sort((a, b) => {
              // First priority: Exact ID match when searching by ID
              if (isNumericId) {
                if (a.id == query && b.id != query) return -1;
                if (a.id != query && b.id == query) return 1;
              }

              // Second priority: IMDB ID
              if (a.imdb_id && !b.imdb_id) return -1;
              if (!a.imdb_id && b.imdb_id) return 1;

              // Third priority: Avatar
              if (a.avatar && !b.avatar) return -1;
              if (!a.avatar && b.avatar) return 1;

              return 0;
            });

            callback(sortedResults);
          }
        })
        .catch(error => {
          console.error('Contact search error:', error);
        });
    },

    // Show auto-suggest dropdown
    showAutoSuggest: function($input, suggestions, rowId) {
      const self = this;

      // Remove any existing dropdown
      this.hideAutoSuggest();

      if (suggestions.length === 0) return;

      // Get list of already selected contact IDs (excluding current row)
      const selectedContactIds = this.config.data
        .filter(d => d.contact_id && d.title_contact_id !== rowId)
        .map(d => d.contact_id);

      // Create dropdown
      const $dropdown = $('<div class="contact-suggestions"></div>');

      suggestions.forEach(contact => {
        const canEditContact = window.sflow?.permissions?.can_edit_contact || false;
        const isAlreadySelected = selectedContactIds.includes(contact.id);

        const $suggestion = $(`
          <div class="suggestion-item ${isAlreadySelected ? 'suggestion-disabled' : ''}" ${isAlreadySelected ? 'title="Contact is already in list"' : ''} data-contact-id="${contact.id}">
            ${contact.avatar ?
    `<img src="${contact.avatar}" alt="${contact.name}" class="suggestion-avatar">` :
    `<div class="suggestion-avatar-placeholder">${this.getInitials(contact.name)}</div>`
  }
            <div class="suggestion-details">
              <div class="suggestion-name">${contact.name}</div>
              <div class="suggestion-meta">
                ${contact.id ? `ID: ${contact.id}` : ''}
                ${contact.imdb_id ? `${contact.id ? ' | ' : ''}IMDB: ${contact.imdb_id}` : ''}
              </div>
            </div>
            ${canEditContact ?
    `<a href="/contact-person-edit?action=edit&id=${contact.id}"
                  class="suggestion-edit-link"
                  title="Matched existing contact"
                  target="_blank"
                  onclick="event.stopPropagation()">
                <i class="fas fa-edit"></i>
              </a>` : ''
  }
          </div>
        `);

        if (!isAlreadySelected) {
          $suggestion.on('click', () => {
            this.selectContact(rowId, contact);
            this.hideAutoSuggest();
          });
        }

        $dropdown.append($suggestion);
      });

      // Append dropdown to body and position it absolutely
      $('body').append($dropdown);

      // Position dropdown below the input
      const inputRect = $input[0].getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

      $dropdown.css({
        position: 'absolute',
        top: inputRect.bottom + scrollTop + 2 + 'px',
        left: inputRect.left + scrollLeft + 'px',
        width: Math.max(inputRect.width, 300) + 'px',
        zIndex: 10000  // Even higher z-index since it's now on body
      });

      // Store reference to input for repositioning on scroll
      $dropdown.data('input', $input);

      // Reposition on scroll or resize
      const repositionDropdown = () => {
        const newInputRect = $input[0].getBoundingClientRect();
        const newScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const newScrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        $dropdown.css({
          top: newInputRect.bottom + newScrollTop + 2 + 'px',
          left: newInputRect.left + newScrollLeft + 'px'
        });
      };

      $(window).on('scroll.autosuggest resize.autosuggest', repositionDropdown);

      // Check if dropdown would go off-screen on desktop
      setTimeout(() => {
        if (window.innerWidth > 1200) {
          const dropdownRect = $dropdown[0].getBoundingClientRect();
          const windowWidth = window.innerWidth;

          if (dropdownRect.right > windowWidth - 20) {
            // Adjust position to keep dropdown on screen
            const newLeft = windowWidth - $dropdown.outerWidth() - 20;
            $dropdown.css('left', newLeft + 'px');
          }
        }
      }, 0);

      // Close on click outside
      $(document).on('click.autosuggest', (e) => {
        if (!$(e.target).closest('.contact-suggestions, input[data-field="name"]').length) {
          this.hideAutoSuggest();
        }
      });
    },

    // Show loading indicator for auto-suggest
    showAutoSuggestLoading: function($input) {
      // Remove any existing dropdown
      this.hideAutoSuggest();

      // Create loading dropdown
      const $dropdown = $('<div class="contact-suggestions contact-suggestions-loading"></div>');
      $dropdown.html('<div class="suggestion-loading"><i class="fas fa-spinner fa-spin"></i> Searching contacts...</div>');

      // Append to body and position absolutely
      $('body').append($dropdown);

      // Position dropdown below the input
      const inputRect = $input[0].getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

      $dropdown.css({
        position: 'absolute',
        top: inputRect.bottom + scrollTop + 2 + 'px',
        left: inputRect.left + scrollLeft + 'px',
        width: Math.max(inputRect.width, 300) + 'px',
        zIndex: 10000
      });
    },

    // Hide auto-suggest dropdown
    hideAutoSuggest: function() {
      $('.contact-suggestions').remove();
      $(document).off('click.autosuggest');
      $(window).off('scroll.autosuggest resize.autosuggest');
    },

    // Select a contact from suggestions
    selectContact: function(rowId, contact) {
      const item = this.config.data.find(d => d.title_contact_id === rowId);
      if (!item) return;

      // Check if this contact is already in the list
      const isDuplicate = this.config.data.some(d =>
        d.contact_id === contact.id && d.title_contact_id !== rowId,
      );

      if (isDuplicate) {
        this.showNotification('This contact is already in the cast & crew list', 'warning');
        return;
      }

      // Update item with contact data
      item.contact_id = contact.id;
      item.name = contact.name;
      item.c_avatar = contact.avatar || null; // Ensure null instead of undefined
      item.c_imdb_id = contact.imdb_id;
      item.matched = true;

      // Mark as changed
      this.config.unsavedChanges.add(rowId);

      // Update the UI
      this.updatePersonRow(rowId);

      // Check if user can edit contact
      const canEditContact = window.STUDIODOME_PERMISSIONS?.can_edit_contact || false;
    },

    // Update a single person row after contact match
    updatePersonRow: function(id) {
      const person = this.config.data.find(d => d.title_contact_id === id);
      if (!person) return;

      const $component = $(`.person-component[data-id="${id}"]`);
      const $nameInput = $component.find('input[data-field="name"]');
      const $newIndicator = $component.find('.new-contact-indicator');

      // Update avatar
      const $avatarContainer = $component.find('.person-avatar');

      // Clear existing content
      $avatarContainer.empty();

      // Check if this is Shaked Berenson
      const isShakedBerenson = person.name && person.name.toLowerCase().includes('shaked berenson');
      const sparklerClass = isShakedBerenson ? 'sparkler-effect' : '';

      if (person.c_avatar) {
        // User has avatar - show image
        const avatarHtml = `<img src="${person.c_avatar}" alt="${person.name}" onerror="this.style.display='none'">`;
        $avatarContainer.html(avatarHtml);
        $avatarContainer.removeClass('person-avatar-placeholder');
        if (sparklerClass) {
          $avatarContainer.addClass(sparklerClass);
        }
      } else {
        // User has no avatar - show placeholder
        const placeholderHtml = `<i class="fas fa-user"></i>`;
        $avatarContainer.html(placeholderHtml);
        $avatarContainer.addClass('person-avatar-placeholder');
        if (sparklerClass) {
          $avatarContainer.addClass(sparklerClass);
        }
      }

      $newIndicator.remove();

      // Update name
      $nameInput.val(person.name);

      // Add matched indicator
      if (person.matched && !$component.find('.matched-indicator').length) {
        const canEditContact = window.sflow?.permissions?.can_edit_contact || false;
        const matchedIndicatorHtml = canEditContact && person.contact_id ?
          `<div class="matched-indicator" title="Matched to existing contact">
            <a href="/contact-person-edit?action=edit&id=${person.contact_id}"
                class="matched-edit-link"
                title="Matched existing contact"
                target="_blank">
              <i class="fas fa-check-circle"></i>
            </a>
          </div>` :
          '<div class="matched-indicator" title="Matched to existing contact"><i class="fas fa-check-circle"></i></div>';
        $component.find('.person-details').prepend(matchedIndicatorHtml);
      }

      // Update component state
      this.updatePersonComponent(id);
    },

    // Handle role toggle
    handleRoleToggle: function(e) {
      const $checkbox = $(e.currentTarget);
      const id = $checkbox.data('id');
      const role = $checkbox.data('role');
      const roleId = this.config.reverseRoleMap[role];
      const isChecked = $checkbox.prop('checked');

      // Find the person
      const person = this.config.data.find(d => d.title_contact_id === id);
      if (!person) return;

      // Initialize contact_types if needed
      if (!Array.isArray(person.contact_types)) {
        person.contact_types = [];
      }

      // Update role
      const index = person.contact_types.indexOf(roleId);
      if (isChecked && index === -1) {
        person.contact_types.push(roleId);
      } else if (!isChecked && index > -1) {
        person.contact_types.splice(index, 1);
      }

      // Mark as changed
      this.config.unsavedChanges.add(id);

      // Validate the row
      this.validateRow(person);

      // Update UI
      this.updatePersonComponent(id);
      this.updateSaveButton();
      this.showUnsavedIndicator();
      this.updateIndicators();

      // Update character field visibility if actor role changed
      if (role === 'actor') {
        const hasActor = person.contact_types.includes(roleId);
        $checkbox.closest('.person-component').find('.person-character')
          .toggleClass('hidden', !hasActor);
      }
    },

    // Update person component UI
    updatePersonComponent: function(id) {
      const $component = $(`.person-component[data-id="${id}"]`);
      const hasChanges = this.config.unsavedChanges.has(id);
      const isInvalid = this.config.invalidRows.has(id);

      $component.toggleClass('has-changes', hasChanges);
      $component.toggleClass('invalid', isInvalid);
      $component.find('.save-person').prop('disabled', !hasChanges);
    },

    // Handle search
    handleSearch: function(searchTerm) {
      const term = searchTerm.toLowerCase();

      // Show/hide clear button based on search term
      $('#clear-search').toggle(searchTerm.length > 0);

      if (!term) {
        this.config.filteredData = [...this.config.data];
      } else {
        this.config.filteredData = this.config.data.filter(person => {
          const name = (person.name || '').toLowerCase();
          const character = (person.contact_character_name || '').toLowerCase();
          return name.includes(term) || character.includes(term);
        });
      }

      this.renderList();
    },

    // Clear search
    clearSearch: function() {
      $('#search-cast-crew').val('').trigger('input');
    },

    // Move person up or down
    movePerson: function(id, direction) {
      const currentIndex = this.config.filteredData.findIndex(p =>
        p.title_contact_id === id,
      );

      if (currentIndex === -1) return;

      const newIndex = currentIndex + direction;

      if (newIndex < 0 || newIndex >= this.config.filteredData.length) return;

      // Swap the items in filtered data
      const temp = this.config.filteredData[currentIndex];
      this.config.filteredData[currentIndex] = this.config.filteredData[newIndex];
      this.config.filteredData[newIndex] = temp;

      // Update display orders in main data array
      this.config.filteredData.forEach((item, index) => {
        const originalIndex = this.config.data.findIndex(d =>
          d.title_contact_id === item.title_contact_id,
        );
        if (originalIndex !== -1) {
          this.config.data[originalIndex].display_order = index;
          this.config.unsavedChanges.add(item.title_contact_id);
        }
      });

      // Mark both items as changed
      this.config.unsavedChanges.add(this.config.filteredData[currentIndex].title_contact_id);
      this.config.unsavedChanges.add(this.config.filteredData[newIndex].title_contact_id);

      // Re-render the list to update positions without animation
      this.renderList(true);
      this.updateIndicators();
      this.updateSaveButton();
    },

    // Save individual person
    savePerson: function(id) {
      const person = this.config.data.find(d => d.title_contact_id === id);
      if (!person) return;

      const data = {
        title_id: this.config.titleId,
        contact_id: person.id,
        contact_character_name: person.contact_character_name || '',
        contact_types: person.contact_types || [],
        display_order: person.display_order || 0,
      };

      this.apiRequest('PUT', `title-contacts/${id}`, data)
        .then(() => {
          this.config.unsavedChanges.delete(id);
          this.updatePersonComponent(id);
          this.updateSaveButton();

          if (this.config.unsavedChanges.size === 0) {
            this.hideUnsavedIndicator();
          }

          this.showSuccess('Changes saved');
        })
        .catch(error => {
          this.showError(error.message);
        });
    },

    // Save all changes
    saveAll: function() {
      if (this.config.unsavedChanges.size === 0) return Promise.resolve();

      // Check for invalid rows first (excluding deleted rows)
      const nonDeletedInvalidRows = Array.from(this.config.invalidRows).filter(id => {
        const person = this.config.data.find(d => d.title_contact_id === id);
        return person && !person.deleted;
      });

      if (nonDeletedInvalidRows.length > 0) {
        // Get the first non-deleted invalid row
        const firstInvalidId = nonDeletedInvalidRows[0];
        const $invalidRow = $(`.person-component[data-id="${firstInvalidId}"]`);

        // Scroll to the invalid row
        if ($invalidRow.length > 0) {
          const rowTop = $invalidRow.offset().top - 100; // 100px offset from top
          $('html, body').animate({
            scrollTop: rowTop,
          }, 500, () => {
            // After scroll completes, apply invalid highlight
            $invalidRow.addClass('invalid-highlight');
            setTimeout(() => {
              $invalidRow.removeClass('invalid-highlight');
            }, 1000);
          });
        }

        // Show error message
        this.showError(`Please complete all required fields. ${nonDeletedInvalidRows.length} row${nonDeletedInvalidRows.length > 1 ? 's have' : ' has'} missing information (name and at least one role required).`);
        return Promise.reject(new Error('Invalid rows found'));
      }

      // Show loading state on save buttons
      $('#save-all, #save-all-bottom, #save-cast-crew').prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Saving...');

      const promises = Array.from(this.config.unsavedChanges).map(id => {
        const person = this.config.data.find(d => d.title_contact_id === id);
        if (!person) return Promise.resolve();

        // Handle deleted rows
        if (person.deleted) {
          // Only delete if it's an existing row
          if (!id.toString().startsWith('new_')) {
            return this.apiRequest('DELETE', `title-contacts/${id}`);
          }
          return Promise.resolve();
        }

        // Check if person has a name (required field)
        if (!person.name || !person.name.trim()) {
          return Promise.reject(new Error(`Name is required for all cast & crew members`));
        }

        const data = {
          title_id: this.config.titleId,
          contact_character_name: person.contact_character_name || '',
          contact_types: person.contact_types || [],
          display_order: person.display_order || 0,
          tc_imdb_character_id: person.tc_imdb_character_id || null,
        };

        // For new entries, we need to create them
        if (id.toString().startsWith('new_')) {
          // For new entries, check if we already have a matched contact
          if (person.contact_id || person.matched_contact_id) {
            // We already have a contact ID from matching, just create the title-contact link
            data.contact_id = person.contact_id || person.matched_contact_id;
            return this.apiRequest('POST', 'title-contacts', data)
              .then(result => {
                // Update the local data with the new ID
                const index = this.config.data.findIndex(d => d.title_contact_id === id);
                if (index !== -1 && result.data) {
                  this.config.data[index].title_contact_id = result.data.id;
                  this.config.data[index].id = result.data.contact_id;
                }
                return result;
              });
          } else {
            // No existing contact, create a new one
            // Use the first contact type for the Contact's c_type field
            // contact_types: 2=Actor, 3=Director, 7=Writer, 8=Producer
            const contactType = (person.contact_types && person.contact_types.length > 0)
              ? person.contact_types[0]
              : 2; // Default to Actor if no type specified

            const contactData = {
              name: person.name,
              type: contactType,
            };

            // Add IMDB ID if available
            if (person.c_imdb_id) {
              contactData.imdb_id = person.c_imdb_id;
            }

            // Add avatar if available
            if (person.c_avatar) {
              contactData.avatar = person.c_avatar;
            }

            // Add IMDB URL if available (from person.c_imdb or imdb_link)
            if (person.c_imdb || person.imdb_link) {
              contactData.imdb_url = person.c_imdb || person.imdb_link;
            }

            return this.apiRequest('POST', 'contacts', contactData)
              .then(contactResult => {
                if (contactResult.data && contactResult.data.id) {
                  data.contact_id = contactResult.data.id;

                  // Update local data with matched info
                  if (contactResult.data.matched) {
                    person.matched = true;
                    person.c_avatar = contactResult.data.avatar;
                  }

                  return this.apiRequest('POST', 'title-contacts', data);
                } else {
                  throw new Error('Failed to create contact');
                }
              })
              .then(result => {
                // Update the local data with the new ID
                const index = this.config.data.findIndex(d => d.title_contact_id === id);
                if (index !== -1 && result.data) {
                  this.config.data[index].title_contact_id = result.data.id;
                  this.config.data[index].id = result.data.contact_id;
                }
                return result;
              });
          }
        } else {
          // For existing entries, just update
          data.contact_id = person.id;
          return this.apiRequest('PUT', `title-contacts/${id}`, data);
        }
      });

      return Promise.all(promises)
        .then(() => {
          this.config.unsavedChanges.clear();
          this.config.invalidRows.clear();

          // Hide indicators immediately
          this.hideUnsavedIndicator();

          // Reload data to get proper IDs
          this.loadData();

          this.showSuccess('All changes saved successfully');
        })
        .catch(error => {
          this.showError(error.message || 'Some changes failed to save');
          console.error('Save error:', error);
          throw error; // Re-throw to allow external handling
        })
        .finally(() => {
          // Restore save button text
          $('#save-all, #save-all-bottom, #save-cast-crew').html('<i class="fas fa-save"></i> Save Cast & Crew Changes')
            .prop('disabled', false);
          this.updateSaveButton();
          this.updateIndicators();
        });
    },

    // Check if there are unsaved changes
    hasUnsavedChanges: function() {
      return this.config.unsavedChanges.size > 0;
    },

    // Save and return promise for external use
    save: function() {
      return this.saveAll();
    },

    // Delete person (soft delete until save)
    deletePerson: function(id) {
      // Mark the person as deleted
      const person = this.config.data.find(d => d.title_contact_id === id);
      if (!person) return;

      // Set deleted flag
      person.deleted = true;

      // Add to unsaved changes
      this.config.unsavedChanges.add(id);

      // Re-validate to remove from invalid rows if it was invalid
      this.validateRow(person);

      // Move deleted item to the end of the list
      const index = this.config.filteredData.findIndex(d => d.title_contact_id === id);
      if (index > -1) {
        const [deletedItem] = this.config.filteredData.splice(index, 1);
        this.config.filteredData.push(deletedItem);
      }

      // Re-render the list
      this.renderList();
      this.updateSaveButton();
      this.updateIndicators();
    },

    // Add new empty row
    addNewRow: function() {
      const newPerson = {
        title_contact_id: 'new_' + Date.now(),
        name: '',
        contact_character_name: '',
        contact_types: [],
        display_order: 0,
        id: null,
        isNew: true,
      };

      // Add to beginning of data arrays
      this.config.data.unshift(newPerson);
      this.config.filteredData.unshift(newPerson);

      // Mark as having unsaved changes
      this.config.unsavedChanges.add(newPerson.title_contact_id);

      // Validate the new row
      this.validateRow(newPerson);

      // Re-render and update UI
      this.renderList();
      this.updateSaveButton();
      this.updateIndicators();

      // Focus the name input of the new row
      setTimeout(() => {
        $(`input[data-id="${newPerson.title_contact_id}"]`).first().focus();
      }, 100);
    },

    // Delete all rows
    deleteAll: function() {
      if (this.config.data.length === 0) {
        this.showError('No cast & crew entries to delete');
        return;
      }

      const confirmMessage = `Are you sure you want to delete all ${this.config.data.length} cast & crew entries?\n\nThis action cannot be undone once saved.`;

      if (!confirm(confirmMessage)) {
        return;
      }

      // Mark all rows as deleted
      this.config.data.forEach(person => {
        person.deleted = true;
        this.config.unsavedChanges.add(person.title_contact_id);
      });

      // Clear filtered data
      this.config.filteredData = [];

      // Re-render the list (will be empty)
      this.renderList();
      this.updateSaveButton();
      this.updateIndicators();

      this.showSuccess('All cast & crew entries marked for deletion. Click Save to confirm.');
    },

    // Import modal
    openImportModal: function(type) {
      $('#import-modal-title').text(type === 'csv' ? 'Import from CSV' : 'Import from IMDB');

      let content = '';
      if (type === 'csv') {
        content = this.getCSVImportContent();
      } else {
        content = this.getIMDBImportContent();
      }

      $('#import-content').html(content);
      $('#import-modal').foundation('open');

      this.bindImportEvents(type);
    },

    getCSVImportContent: function() {
      return `
                <div class="import-section">
                    <div class="import-tabs">
                        <button class="tab-button active" data-tab="upload">
                            <i class="fas fa-file-upload"></i> Upload File
                        </button>
                        <button class="tab-button" data-tab="paste">
                            <i class="fas fa-paste"></i> Paste Data
                        </button>
                    </div>

                    <div class="tab-content" id="upload-tab" style="display: block;">
                        <div class="format-instructions">
                            <h5>CSV Format: Name, Character, Director(x), Producer(x), Writer(x), Actor(x)</h5>
                            <p class="format-example">Robert Downey Jr., Tony Stark, , , , x<br>
                            Christopher Nolan, , x, , x, <br>
                            Jon Favreau, Happy Hogan, x, x, , x</p>
                            <div class="download-sample">
                                <button class="btn btn-sm btn-glass" id="download-sample-csv">
                                    <i class="fas fa-download"></i> Download Sample CSV
                                </button>
                            </div>
                        </div>
                        <input type="file" id="csv-file" accept=".csv,.tsv" style="display: none;">
                        <div class="csv-upload-area" id="csv-upload-area">
                            <i class="fas fa-cloud-upload-alt"></i>
                            <div class="upload-text">Drop CSV/TSV file here or click to browse</div>
                            <div class="upload-subtext">Supported formats: .csv, .tsv</div>
                        </div>
                    </div>

                    <div class="tab-content" id="paste-tab" style="display: none;">
                        <div class="paste-instructions">
                            <p><strong>Format:</strong> Name, Character, Director(x), Producer(x), Writer(x), Actor(x)</p>

                            <div class="sample-table-container">
                                <h6>Sample Data (copy into Excel / Google Sheets):</h6>
                                <table class="sample-paste-table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Character</th>
                                            <th>Director</th>
                                            <th>Producer</th>
                                            <th>Writer</th>
                                            <th>Actor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Robert Downey Jr.</td>
                                            <td>Tony Stark</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>x</td>
                                        </tr>
                                        <tr>
                                            <td>Christopher Nolan</td>
                                            <td></td>
                                            <td>x</td>
                                            <td></td>
                                            <td>x</td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Kevin Feige</td>
                                            <td></td>
                                            <td></td>
                                            <td>x</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        <tr>
                                            <td>Jon Favreau</td>
                                            <td>Happy Hogan</td>
                                            <td>x</td>
                                            <td>x</td>
                                            <td></td>
                                            <td>x</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <textarea id="csv-paste-area" placeholder="Paste your data here...&#10;&#10;Example:&#10;John Doe, Main Character, actor&#10;Jane Smith, , director/writer&#10;Bob Johnson, , producer/director" rows="10"></textarea>
                        <button class="btn btn-primary btn-glass" id="process-paste-btn">
                            <i class="fas fa-check"></i> Process Pasted Data
                        </button>
                    </div>

                    <div id="csv-preview" style="display: none;">

                        <!-- Import Notice -->
                        <div class="import-notice">
                            <i class="fas fa-info-circle"></i>
                            <span>This preview shows what will be imported. <strong>No data is saved until you click import, and then click "Save All" at the bottom of the page.</strong></span>
                        </div>

                        <!-- Quick Filters -->
                        <div class="import-quick-filters">
                            <div class="filter-controls">
                                <div class="filter-row">
                                    <div class="role-selector" data-role="actor">
                                        <span class="role-label">Select top</span>
                                        <div class="number-control">
                                            <input type="number" class="role-count" value="6" min="0" max="999" data-role="actor">
                                            <div class="spinner-buttons">
                                                <button class="spinner-up" data-role="actor"><i class="fas fa-chevron-up"></i></button>
                                                <button class="spinner-down" data-role="actor"><i class="fas fa-chevron-down"></i></button>
                                            </div>
                                        </div>
                                        <span class="role-name">actors</span>
                                    </div>

                                    <div class="role-selector" data-role="director">
                                        <span class="role-label">Select top</span>
                                        <div class="number-control">
                                            <input type="number" class="role-count" value="3" min="0" max="999" data-role="director">
                                            <div class="spinner-buttons">
                                                <button class="spinner-up" data-role="director"><i class="fas fa-chevron-up"></i></button>
                                                <button class="spinner-down" data-role="director"><i class="fas fa-chevron-down"></i></button>
                                            </div>
                                        </div>
                                        <span class="role-name">directors</span>
                                    </div>

                                    <div class="role-selector" data-role="producer">
                                        <span class="role-label">Select top</span>
                                        <div class="number-control">
                                            <input type="number" class="role-count" value="3" min="0" max="999" data-role="producer">
                                            <div class="spinner-buttons">
                                                <button class="spinner-up" data-role="producer"><i class="fas fa-chevron-up"></i></button>
                                                <button class="spinner-down" data-role="producer"><i class="fas fa-chevron-down"></i></button>
                                            </div>
                                        </div>
                                        <span class="role-name">producers</span>
                                    </div>

                                    <div class="role-selector" data-role="writer">
                                        <span class="role-label">Select top</span>
                                        <div class="number-control">
                                            <input type="number" class="role-count" value="3" min="0" max="999" data-role="writer">
                                            <div class="spinner-buttons">
                                                <button class="spinner-up" data-role="writer"><i class="fas fa-chevron-up"></i></button>
                                                <button class="spinner-down" data-role="writer"><i class="fas fa-chevron-down"></i></button>
                                            </div>
                                        </div>
                                        <span class="role-name">writers</span>
                                    </div>

                                    <button class="btn btn-sm btn-secondary deselect-all-btn" id="deselect-all-csv">
                                        <i class="fas fa-times"></i> Deselect All
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="preview-table-container"></div>
                        <div class="import-actions">
                            <button class="btn btn-secondary btn-glass" id="reset-csv-import">
                                <i class="fas fa-redo"></i> Reset
                            </button>
                            <button class="btn btn-danger btn-glass" id="replace-all-csv">
                                <i class="fas fa-sync-alt"></i> Replace All Data
                            </button>
                            <button class="btn btn-primary btn-glass" id="perform-csv-import">
                                <i class="fas fa-upload"></i> Import Selected
                            </button>
                        </div>
                    </div>
                </div>
            `;
    },

    getIMDBImportContent: function() {
      // Check if we have an IMDB ID to prepopulate
      let imdbId = window.sflow?.title?.imdb_id;
      let defaultUrl = '';

      // If no IMDB ID from title, check #t_imdb or #review_t_imdb
      if (!imdbId) {
        // First check #t_imdb
        let imdbValue = $('#t_imdb').length > 0 ? $('#t_imdb').val() : '';

        // If not found, check #review_t_imdb
        if (!imdbValue && $('#review_t_imdb').length > 0) {
          imdbValue = $('#review_t_imdb').val();
        }

        if (imdbValue) {
          // Extract IMDB ID from various formats
          const match = imdbValue.match(/tt\d+/);
          if (match) {
            imdbId = match[0];
            defaultUrl = `https://www.imdb.com/title/${imdbId}/`;
          } else if (imdbValue.startsWith('http')) {
            // It's a URL, just use it as is
            defaultUrl = imdbValue;
          }
        }
      } else if (imdbId) {
        defaultUrl = `https://www.imdb.com/title/${imdbId}/`;
      }

      const placeholder = defaultUrl ? defaultUrl : 'Enter IMDB URL (e.g., https://www.imdb.com/title/tt1234567/)';

      return `
                <div class="import-section">
                    <div class="imdb-search">
                        <input style="margin-bottom: 0" type="text" id="imdb-url" placeholder="${placeholder}" value="${defaultUrl}">
                        <button class="btn btn-primary btn-glass" id="fetch-imdb-btn">
                            <i class="fas fa-search"></i> Fetch Cast & Crew
                        </button>
                    </div>
                    ${window.sflow?.isAdmin ? `
                    <div class="imdb-options">
                        <label>
                            <input style="margin-bottom: 0" type="checkbox" id="force-override-imdb" value="1">
                            Force refresh IMDB data (override cached data)
                        </label>
                    </div>` : ''}
                    <div id="imdb-preview" style="display: none;">

                        <!-- Import Notice -->
                        <div class="import-notice">
                            <i class="fas fa-info-circle"></i>
                            <span>This preview shows what will be imported. <strong>No data is saved until you click import, and then click "Save All" at the bottom of the page.</strong></span>
                        </div>

                        <!-- Quick Filters -->
                        <div class="import-quick-filters">
                            <div class="filter-controls">
                                <div class="filter-row">
                                    <div class="role-selector" data-role="actor">
                                        <span class="role-label">Select top</span>
                                        <div class="number-control">
                                            <input type="number" class="role-count" value="6" min="0" max="999" data-role="actor">
                                            <div class="spinner-buttons">
                                                <button class="spinner-up" data-role="actor"><i class="fas fa-chevron-up"></i></button>
                                                <button class="spinner-down" data-role="actor"><i class="fas fa-chevron-down"></i></button>
                                            </div>
                                        </div>
                                        <span class="role-name">actors</span>
                                    </div>

                                    <div class="role-selector" data-role="director">
                                        <span class="role-label">Select top</span>
                                        <div class="number-control">
                                            <input type="number" class="role-count" value="3" min="0" max="999" data-role="director">
                                            <div class="spinner-buttons">
                                                <button class="spinner-up" data-role="director"><i class="fas fa-chevron-up"></i></button>
                                                <button class="spinner-down" data-role="director"><i class="fas fa-chevron-down"></i></button>
                                            </div>
                                        </div>
                                        <span class="role-name">directors</span>
                                    </div>

                                    <div class="role-selector" data-role="producer">
                                        <span class="role-label">Select top</span>
                                        <div class="number-control">
                                            <input type="number" class="role-count" value="3" min="0" max="999" data-role="producer">
                                            <div class="spinner-buttons">
                                                <button class="spinner-up" data-role="producer"><i class="fas fa-chevron-up"></i></button>
                                                <button class="spinner-down" data-role="producer"><i class="fas fa-chevron-down"></i></button>
                                            </div>
                                        </div>
                                        <span class="role-name">producers</span>
                                    </div>

                                    <div class="role-selector" data-role="writer">
                                        <span class="role-label">Select top</span>
                                        <div class="number-control">
                                            <input type="number" class="role-count" value="3" min="0" max="999" data-role="writer">
                                            <div class="spinner-buttons">
                                                <button class="spinner-up" data-role="writer"><i class="fas fa-chevron-up"></i></button>
                                                <button class="spinner-down" data-role="writer"><i class="fas fa-chevron-down"></i></button>
                                            </div>
                                        </div>
                                        <span class="role-name">writers</span>
                                    </div>

                                    <button class="btn btn-sm btn-secondary deselect-all-btn" id="deselect-all-imdb">
                                        <i class="fas fa-times"></i> Deselect All
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="preview-table-container"></div>
                        <div class="import-actions">
                            <button class="btn btn-danger btn-glass" id="replace-all-imdb">
                                <i class="fas fa-sync-alt"></i> Replace All Data
                            </button>
                            <button class="btn btn-primary btn-glass" id="perform-imdb-import-btn">
                                <i class="fas fa-upload"></i> Import Selected
                            </button>
                        </div>
                    </div>
                </div>
            `;
    },

    bindImportEvents: function(type) {
      if (type === 'csv') {
        // Tab switching
        $('.tab-button').on('click', (e) => {
          const tab = $(e.currentTarget).data('tab');
          $('.tab-button').removeClass('active');
          $(e.currentTarget).addClass('active');
          $('.tab-content').hide();
          $(`#${tab}-tab`).show();
        });

        // File upload events
        const uploadArea = $('#csv-upload-area');
        const fileInput = $('#csv-file');

        uploadArea.on('click', () => fileInput.click());

        uploadArea.on('dragover', (e) => {
          e.preventDefault();
          uploadArea.addClass('drag-over');
        });

        uploadArea.on('dragleave', () => {
          uploadArea.removeClass('drag-over');
        });

        uploadArea.on('drop', (e) => {
          e.preventDefault();
          uploadArea.removeClass('drag-over');
          const files = e.originalEvent.dataTransfer.files;
          if (files.length > 0) {
            this.handleCSVFile(files[0]);
          }
        });

        fileInput.on('change', (e) => {
          if (e.target.files.length > 0) {
            this.handleCSVFile(e.target.files[0]);
          }
        });

        // Paste events
        $('#process-paste-btn').on('click', () => {
          const pastedData = $('#csv-paste-area').val();
          if (pastedData.trim()) {
            this.processPastedData(pastedData);
          } else {
            this.showError('Please paste some data first');
          }
        });

        // Download sample CSV button
        $('#download-sample-csv').on('click', () => this.downloadSampleCSV());

        // Reset button
        $('#reset-csv-import').on('click', () => this.resetCSVImport());

        // Import button
        $('#perform-csv-import').on('click', () => this.performCSVImport());

        // Replace all button
        $('#replace-all-csv').on('click', () => this.replaceAllWithImport('csv'));

        // Role count input change
        $('#csv-preview').on('change', '.role-count', (e) => {
          const $input = $(e.currentTarget);
          const role = $input.data('role');
          const count = parseInt($input.val()) || 0;
          this.selectTopImport('csv', role, count);
        });

        // Spinner up button
        $('#csv-preview').on('click', '.spinner-up', (e) => {
          e.preventDefault();
          const role = $(e.currentTarget).data('role');
          const $input = $(`#csv-preview .role-count[data-role="${role}"]`);
          const currentVal = parseInt($input.val()) || 0;
          const newVal = Math.min(currentVal + 1, 999);
          $input.val(newVal).trigger('change');
        });

        // Spinner down button
        $('#csv-preview').on('click', '.spinner-down', (e) => {
          e.preventDefault();
          const role = $(e.currentTarget).data('role');
          const $input = $(`#csv-preview .role-count[data-role="${role}"]`);
          const currentVal = parseInt($input.val()) || 0;
          const newVal = Math.max(currentVal - 1, 0);
          $input.val(newVal).trigger('change');
        });

        // Deselect all button
        $('#deselect-all-csv').on('click', () => {
          $('.import-select-csv').prop('checked', false);
          $('#select-all-csv').prop('checked', false);
        });
      } else if (type === 'imdb') {
        // Bind IMDB fetch button
        $('#fetch-imdb-btn').on('click', () => this.fetchIMDBData());

        // Bind IMDB import button
        $('#perform-imdb-import-btn').on('click', () => this.performIMDBImport());

        // Replace all button
        $('#replace-all-imdb').on('click', () => this.replaceAllWithImport('imdb'));

        // Role count input change
        $('#imdb-preview').on('change', '.role-count', (e) => {
          const $input = $(e.currentTarget);
          const role = $input.data('role');
          const count = parseInt($input.val()) || 0;
          this.selectTopImport('imdb', role, count);
          this.collapseUncheckedRows('imdb');
        });

        // Spinner up button
        $('#imdb-preview').on('click', '.spinner-up', (e) => {
          e.preventDefault();
          const role = $(e.currentTarget).data('role');
          const $input = $(`#imdb-preview .role-count[data-role="${role}"]`);
          const currentVal = parseInt($input.val()) || 0;
          const newVal = Math.min(currentVal + 1, 999);
          $input.val(newVal).trigger('change');
        });

        // Spinner down button
        $('#imdb-preview').on('click', '.spinner-down', (e) => {
          e.preventDefault();
          const role = $(e.currentTarget).data('role');
          const $input = $(`#imdb-preview .role-count[data-role="${role}"]`);
          const currentVal = parseInt($input.val()) || 0;
          const newVal = Math.max(currentVal - 1, 0);
          $input.val(newVal).trigger('change');
        });

        // Deselect all button
        $('#deselect-all-imdb').on('click', () => {
          $('.import-select-imdb').prop('checked', false);
          $('#select-all-imdb').prop('checked', false);
        });

        // Bind enter key on IMDB URL input
        $('#imdb-url').on('keypress', (e) => {
          if (e.which === 13) {
            e.preventDefault();
            this.fetchIMDBData();
          }
        });
      }
    },

    // UI State Management
    updateSaveButton: function() {
      const hasChanges = this.config.unsavedChanges.size > 0;

      // Disable save button only if no changes
      $('#save-all, #save-all-bottom').prop('disabled', !hasChanges);

      // If no changes, ensure button text is reset
      if (!hasChanges) {
        $('#save-all, #save-all-bottom').html('<i class="fas fa-save"></i> Save All');
      }
    },

    validateRow: function(person) {
      // Skip validation for deleted rows
      if (person.deleted) {
        this.config.invalidRows.delete(person.title_contact_id);
        return true;
      }

      // Validate that name is not empty AND at least one role is selected
      const hasName = person.name?.trim() ? true : false;
      const hasRoles = person.contact_types && person.contact_types.length > 0;
      const isValid = hasName && hasRoles;

      if (!isValid) {
        this.config.invalidRows.add(person.title_contact_id);
      } else {
        this.config.invalidRows.delete(person.title_contact_id);
      }
      return isValid;
    },

    updateIndicators: function() {
      const hasUnsaved = this.config.unsavedChanges.size > 0;

      // Count only non-deleted invalid rows
      const nonDeletedInvalidRows = Array.from(this.config.invalidRows).filter(id => {
        const person = this.config.data.find(d => d.title_contact_id === id);
        return person && !person.deleted;
      });
      const invalidCount = nonDeletedInvalidRows.length;

      // Update unsaved changes indicator
      if (hasUnsaved || invalidCount > 0) {
        $('.indicators-wrapper').fadeIn(200);
      } else {
        $('.indicators-wrapper').fadeOut(200);
      }

      // Toggle visibility of individual indicators
      $('.unsaved-indicator').toggle(hasUnsaved);
      $('.invalid-indicator').toggle(invalidCount > 0);

      // Update invalid count - only show if greater than 0
      if (invalidCount > 0) {
        $('.invalid-count').text(invalidCount);
      }
    },

    showUnsavedIndicator: function() {
      const hasUnsaved = this.config.unsavedChanges.size > 0;

      // Count only non-deleted invalid rows
      const nonDeletedInvalidRows = Array.from(this.config.invalidRows).filter(id => {
        const person = this.config.data.find(d => d.title_contact_id === id);
        return person && !person.deleted;
      });
      const invalidCount = nonDeletedInvalidRows.length;

      if (hasUnsaved || invalidCount > 0) {
        $('.indicators-wrapper').fadeIn(200);
      }
    },

    hideUnsavedIndicator: function() {
      // Hide all indicator wrappers (both top and bottom)
      $('.indicators-wrapper').fadeOut(200);
    },

    // Clean up any stuck drag operations
    cleanupDragOperations: function() {
      // Remove drag classes
      $('.person-component').removeClass('dragging drag-over drop-indicator drop-indicator-above drop-indicator-below');

      // Remove draggable attributes if needed
      $('.person-component').removeAttr('draggable');

      // Remove event handlers
      $('#cast-crew-items').off('.dragdrop');
      $(document).off('.dragdrop');
    },

    // Navigation guard
    setupNavigationGuard: function() {
      const self = this;

      window.addEventListener('beforeunload', function(e) {
        // Clean up drag operations when leaving page
        self.cleanupDragOperations();

        if (self.config.unsavedChanges.size > 0) {
          e.preventDefault();
          e.returnValue = '';
          return '';
        }
      });
    },

    // API helper
    apiRequest: function(method, endpoint, data = null) {
      const url = `${this.config.baseUrl}/api/${endpoint}`;
      const headers = {
        'Content-Type': 'application/json',
        'X-API-Key': this.config.apiKey,
        'X-API-Secret': this.config.apiSecret,
      };

      const options = {
        method: method,
        headers: headers,
      };

      if (data && method !== 'GET') {
        options.body = JSON.stringify(data);
      }

      return fetch(url, options)
        .then(response => response.json())
        .then(result => {
          if (!result.success) {
            throw new Error(result.message || 'API request failed');
          }
          return result;
        });
    },

    // Helper functions
    getInitials: function(name) {
      return name.split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    },

    // Notifications
    showSuccess: function(message) {
      this.showNotification(message, 'success');
    },

    showError: function(message) {
      this.showNotification(message, 'error');
    },

    showInfo: function(message) {
      this.showNotification(message, 'info');
    },

    showNotification: function(message, type) {
      const notification = $(`
                <div class="notification notification-${type}">
                    <i class="fas fa-${type === 'success' ? 'check-circle' : type === 'error' ? 'exclamation-circle' : 'info-circle'}"></i>
                    <span>${message}</span>
                </div>
            `);

      $('body').append(notification);

      setTimeout(() => notification.addClass('show'), 10);

      setTimeout(() => {
        notification.removeClass('show');
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    },

    // Placeholder functions for import
    resetImport: function() {
      $('#csv-upload-area').show();
      $('#csv-preview').hide();
      $('#csv-file').val('');
    },

    fetchIMDBData: function() {
      const imdbUrl = $('#imdb-url').val().trim();
      if (!imdbUrl) {
        this.showError('Please enter an IMDB URL');
        return;
      }

      // Extract IMDB ID from URL
      const imdbMatch = imdbUrl.match(/\/title\/(tt\d+)/);
      if (!imdbMatch) {
        this.showError('Invalid IMDB URL format. Please use a URL like: https://www.imdb.com/title/tt1234567/');
        return;
      }

      const imdbId = imdbMatch[1];
      const $button = $('#import-modal button:contains("Fetch")');
      const originalText = $button.html();

      // Show loading state
      $button.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Fetching...');

      // Check if user wants to force override
      const forceOverride = $('#force-override-imdb').is(':checked');

      // Fetch from IMDB API with title ID for caching
      const params = new URLSearchParams({
        imdb: imdbId,
        title_id: this.config.titleId,
        disableCache: forceOverride,
      });

      this.apiRequest('GET', `imdb?${params.toString()}`)
        .then(result => {
          if (result.success && result.data) {
            this.displayIMDBPreview(result.data);
          } else {
            this.showError('Failed to fetch IMDB data');
          }
        })
        .catch(error => {
          this.showError('Error fetching IMDB data: ' + error.message);
        })
        .finally(() => {
          $button.prop('disabled', false).html(originalText);
        });
    },

    displayIMDBPreview: function(imdbData) {
      console.log('IMDB Data received:', imdbData);

      // Process all people from credits array in the order they appear
      const peopleList = [];
      const seenIds = new Set();

      // Only process credits array, maintaining its order
      if (imdbData.credits && Array.isArray(imdbData.credits)) {
        // IMDB uses singular when one person has the role, plural when several do.
        // Map both forms so we never silently drop a credit.
        const roleMap = {
          'Director': 'director',
          'Directors': 'director',
          'Writer': 'writer',
          'Writers': 'writer',
          'Producer': 'producer',
          'Producers': 'producer',
          'Cast': 'actor',
        };

        imdbData.credits.forEach((credit, creditIndex) => {
          if (!credit || !credit.person || !credit.person.name) return;

          const mappedRole = roleMap[credit.role];
          if (!mappedRole) return;

          // Use person.id when available; fall back to name for dedup
          const personId = credit.person.id || null;
          const dedupKey = personId || credit.person.name.trim().toLowerCase();

          // Check if person already exists (by IMDB id or by name)
          const existingPersonIndex = peopleList.findIndex(p =>
            (personId && p.imdbId && p.imdbId === personId) ||
            (!personId && !p.imdbId && p.name.trim().toLowerCase() === dedupKey),
          );

          if (existingPersonIndex !== -1) {
            // Person already exists - add role if not already present
            const existingPerson = peopleList[existingPersonIndex];
            if (!existingPerson.roles.includes(mappedRole)) {
              existingPerson.roles.push(mappedRole);
            }
            // Update character if this is an actor role and we have character info
            if (mappedRole === 'actor' && credit.person.character && !existingPerson.character) {
              existingPerson.character = credit.person.character;
            }
          } else {
            // New person - add in order
            if (personId) seenIds.add(personId);

            // Construct IMDB URL from person ID (nm1234567 -> https://www.imdb.com/name/nm1234567/)
            const imdbUrl = personId && personId.startsWith('nm')
              ? `https://www.imdb.com/name/${personId}/`
              : null;

            peopleList.push({
              name: credit.person.name,
              imdbId: personId,
              imdbUrl: imdbUrl,
              roles: [mappedRole],
              character: credit.person.character || null,
              image: credit.person.image || null,
              orderIndex: creditIndex, // Use the credit index directly to preserve exact order
            });
          }
        });
      }

      // Store IMDB data in the order they were added
      this.config.pendingIMDBData = peopleList;

      // Short-circuit when IMDB returned no usable credits for this title.
      // Without this guard we'd POST {queries: []} to /contacts/bulk-suggest
      // and surface the backend's "Invalid request format" error — confusing
      // because the real cause is "IMDB had no cast/crew for this title",
      // not a malformed request. Happens on brand-new/indie titles whose
      // IMDB page hasn't been populated yet.
      if (peopleList.length === 0) {
        $('.preview-table-container').html(`
          <div class="empty-state" style="padding: 24px; text-align: center; color: #666;">
            <i class="fas fa-info-circle" style="font-size: 24px; opacity: .6;"></i>
            <p style="margin: 10px 0 4px; font-weight: 600;">No cast or crew found on IMDB for this title.</p>
            <p style="margin: 0; font-size: 13px;">
              Try checking <i class="far fa-square"></i> <em>Force refresh IMDB data</em> above, or use
              <strong>Add New Person</strong> to enter people manually.
            </p>
          </div>
        `);
        $('#imdb-preview').show();
        return;
      }

      // Show loading indicator for contact matching
      $('.preview-table-container').html(`
        <div class="matching-contacts-loading">
          <i class="fas fa-spinner fa-spin"></i> Matching contacts with existing database...
        </div>
      `);
      $('#imdb-preview').show();

      // Prepare bulk search data
      const searchQueries = this.config.pendingIMDBData.map(person => ({
        name: person.name,
        imdb_id: person.imdbId || null,
      }));

      // Use bulk API call for contact matching
      this.apiRequest('POST', 'contacts/bulk-suggest', { queries: searchQueries })
        .then(result => {
          if (result.success && result.data) {
            // Map bulk results back to people
            this.config.pendingIMDBData.forEach((person, index) => {
              const matches = result.data[index] || [];
              if (matches.length > 0) {
                // Store all matches
                person.allMatches = matches;

                // Look for match by IMDB ID first, then exact name
                const imdbMatch = person.imdbId ?
                  matches.find(contact => contact.imdb_id === person.imdbId) : null;
                const exactMatch = matches.find(contact =>
                  contact.name.toLowerCase() === person.name.toLowerCase(),
                );

                const match = imdbMatch || exactMatch;
                if (match) {
                  person.matchedContact = match;
                  person.matched_contact_id = match.id;
                  // Keep IMDB data if we have it from IMDB but not in our DB
                  person.matched_imdb_id = match.imdb_id || person.imdbId;
                  // Keep avatar from IMDB if our DB doesn't have one
                  person.matched_avatar = match.avatar || person.image;
                } else if (matches.length === 1) {
                  // If only one match, use it
                  person.matchedContact = matches[0];
                  person.matched_contact_id = matches[0].id;
                  person.matched_imdb_id = matches[0].imdb_id || person.imdbId;
                  person.matched_avatar = matches[0].avatar || person.image;
                } else {
                  // Multiple matches, will show radio list
                  person.multipleMatches = true;
                  // Default to first match
                  person.matchedContact = matches[0];
                  person.matched_contact_id = matches[0].id;
                  person.matched_imdb_id = matches[0].imdb_id || person.imdbId;
                  person.matched_avatar = matches[0].avatar || person.image;
                }
              }
            });
          }
        })
        .catch(error => {
          console.error('Bulk contact matching failed:', error);
          // Fallback to individual requests if bulk fails
          const checkPromises = this.config.pendingIMDBData.map(person => {
            let query = person.name;
            return this.apiRequest('GET', `contacts/suggest?q=${encodeURIComponent(query)}&limit=5`)
              .then(result => {
                if (result.success && result.data && result.data.length > 0) {
                  const imdbMatch = person.imdbId ?
                    result.data.find(contact => contact.imdb_id === person.imdbId) : null;
                  const exactMatch = result.data.find(contact =>
                    contact.name.toLowerCase() === person.name.toLowerCase(),
                  );

                  const match = imdbMatch || exactMatch;
                  if (match) {
                    person.matchedContact = match;
                    person.matched_contact_id = match.id;
                    person.matched_imdb_id = match.imdb_id || person.imdbId;
                    person.matched_avatar = match.avatar || person.image;
                  }
                }
                return person;
              })
              .catch(() => person);
          });
          return Promise.all(checkPromises);
        })
        .then(() => {
          // Use unified preview table component
          ImportPreviewTable.render({
            data: this.config.pendingIMDBData,
            type: 'imdb',
            container: '#imdb-preview .preview-table-container',
            existingData: this.config.data,
            canEditContact: window.sflow?.permissions?.can_edit_contact || false,
            reverseRoleMap: this.config.reverseRoleMap,
          });

          $('#imdb-preview').show();

          // Apply initial filters
          this.applyInitialImportFilters('imdb');
        });
    },

    // Search functionality
    handleSearch: function(searchTerm) {
      const term = searchTerm.toLowerCase().trim();

      if (term === '') {
        this.clearSearch();
        return;
      }

      // Show clear button
      $('#clear-search').show();

      // Filter the data
      this.config.filteredData = this.config.data.filter(person => {
        if (person.deleted) return false;

        const nameMatch = person.name && person.name.toLowerCase().includes(term);
        const characterMatch = person.contact_character_name &&
          person.contact_character_name.toLowerCase().includes(term);

        return nameMatch || characterMatch;
      });

      this.renderList();
    },

    // Apply initial filters when import preview loads
    applyInitialImportFilters: function(type) {
      // Get the default values from the role count inputs
      const container = type === 'csv' ? '#csv-preview' : '#imdb-preview';

      $(container + ' .role-count').each((index, element) => {
        const $input = $(element);
        const role = $input.data('role');
        const count = parseInt($input.val()) || 0;

        if (count > 0) {
          // Apply the filter for this role
          this.selectTopImport(type, role, count);
        }
      });

      // Hide unchecked rows and add a toggle to reveal them
      this.collapseUncheckedRows(type);
    },

    // Collapse unchecked rows with a "Show N more" toggle
    collapseUncheckedRows: function(type) {
      const selectClass = `.import-select-${type}`;
      const $allRows = $(selectClass).closest('tr');
      const $unchecked = $(selectClass + ':not(:checked):not(:disabled)').closest('tr');
      const hiddenCount = $unchecked.length;

      // Remove any existing toggle
      $(`.show-hidden-toggle-${type}`).remove();

      if (hiddenCount === 0) return;

      // Hide unchecked rows
      $unchecked.addClass(`hidden-import-row-${type}`).hide();

      // Add a toggle row after the last visible row
      const $lastVisible = $allRows.not(`.hidden-import-row-${type}`).last();
      $lastVisible.after(`
        <tr class="show-hidden-toggle-${type}" style="cursor:pointer;">
          <td colspan="6" style="text-align:center; padding:10px; color:#4a6cf7; font-weight:500;">
            <i class="fas fa-chevron-down"></i>
            Show ${hiddenCount} more people
          </td>
        </tr>
      `);

      // Click handler for toggle
      $(`.show-hidden-toggle-${type}`).on('click', () => {
        $(`.hidden-import-row-${type}`).show().removeClass(`hidden-import-row-${type}`);
        $(`.show-hidden-toggle-${type}`).remove();
      });
    },

    clearSearch: function() {
      $('#search-cast-crew').val('');
      $('#clear-search').hide();
      this.config.filteredData = [...this.config.data];
      this.renderList();
    },

    // Select top N for imports
    selectTopImport: function(type, role, count) {
      const selectClass = type === 'csv' ? '.import-select-csv' : '.import-select-imdb';
      const data = type === 'csv' ? this.config.pendingCSVData : this.config.pendingIMDBData;

      // Get all indices for this role
      let roleIndices = [];
      data.forEach((person, index) => {
        if (person.roles && person.roles.includes(role)) {
          roleIndices.push(index);
        }
      });

      // First, uncheck all items of this role
      roleIndices.forEach(index => {
        $(selectClass + `[data-index="${index}"]`).prop('checked', false);
      });

      // If count is 0 or negative, we're done (all unchecked)
      if (count <= 0) {
        // Update select all checkbox state
        const allCheckboxes = $(selectClass + ':not(:disabled)');
        const checkedCheckboxes = $(selectClass + ':checked');
        const selectAllId = type === 'csv' ? '#select-all-csv' : '#select-all-imdb';
        $(selectAllId).prop('checked', allCheckboxes.length === checkedCheckboxes.length && allCheckboxes.length > 0);
        return;
      }

      // Now check the top N of this role
      const topN = roleIndices.slice(0, count);
      topN.forEach(index => {
        $(selectClass + `[data-index="${index}"]:not(:disabled)`).prop('checked', true);
      });

      // Update select all checkbox state
      const allCheckboxes = $(selectClass + ':not(:disabled)');
      const checkedCheckboxes = $(selectClass + ':checked');
      const selectAllId = type === 'csv' ? '#select-all-csv' : '#select-all-imdb';
      $(selectAllId).prop('checked', allCheckboxes.length === checkedCheckboxes.length && allCheckboxes.length > 0);
    },

    // Replace all existing data with import data
    replaceAllWithImport: function(type) {
      const confirmMessage = 'WARNING: This will replace ALL existing cast & crew with the imported data.\n\nExisting entries that don\'t match imported data will be deleted.\n\nAre you sure you want to continue?';

      if (!confirm(confirmMessage)) {
        return;
      }

      // Get the import data
      const importData = type === 'csv' ? this.config.pendingCSVData : this.config.pendingIMDBData;

      // Build a set of names from import data for quick lookup
      const importedNames = new Set(importData.map(p => p.name.toLowerCase()));

      // Mark existing entries as deleted ONLY if they don't match any imported data
      this.config.data.forEach(person => {
        if (!person.isNew && !person.deleted) {
          // Check if this person exists in the import data
          const existsInImport = importedNames.has(person.name.toLowerCase());

          if (!existsInImport) {
            // This person is not in the import, so mark for deletion
            person.deleted = true;
            this.config.unsavedChanges.add(person.title_contact_id);
          }
          // If exists in import, it will be updated/kept, not deleted
        }
      });

      // Select all import items
      if (type === 'csv') {
        $('.import-select-csv').prop('checked', true);
      } else {
        $('.import-select-imdb').prop('checked', true);
      }

      // Perform the import
      if (type === 'csv') {
        this.performCSVImport();
      } else {
        this.performIMDBImport();
      }
    },

    findExistingPerson: function(name) {
      return this.config.data.find(p =>
        p.name && p.name.toLowerCase() === name.toLowerCase(),
      );
    },

    willPersonChange: function(existing, newPerson) {
      // Check if roles are different
      const existingRoles = this.getRolesForPerson(existing);
      const rolesChanged = !this.arraysEqual(existingRoles.sort(), newPerson.roles.sort());

      // Check if character changed (for actors)
      const characterChanged = newPerson.roles.includes('actor') &&
        (existing.contact_character_name || '') !== (newPerson.character || '');

      return rolesChanged || characterChanged;
    },

    getPersonChanges: function(existing, newPerson) {
      const changes = [];

      // Check if roles are different
      const existingRoles = this.getRolesForPerson(existing);
      const rolesChanged = !this.arraysEqual(existingRoles.sort(), newPerson.roles.sort());

      if (rolesChanged) {
        changes.push('Roles');
      }

      // Check if character changed (for actors)
      if (newPerson.roles.includes('actor') &&
        (existing.contact_character_name || '') !== (newPerson.character || '')) {
        changes.push('Character name');
      }

      // Check if IMDB ID will be added
      if (!existing.c_imdb_id && newPerson.imdbId) {
        changes.push('IMDB ID');
      }

      // Check if avatar will be added
      if (!existing.c_avatar && newPerson.image) {
        changes.push('Avatar');
      }

      return changes;
    },

    arraysEqual: function(a, b) {
      return a.length === b.length && a.every((val, index) => val === b[index]);
    },

    handleCSVFile: function(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const content = e.target.result;
        this.parseCSVData(content, file.name);
      };

      reader.onerror = () => {
        this.showError('Failed to read file');
      };

      reader.readAsText(file);
    },

    processPastedData: function(data) {
      this.parseCSVData(data, 'pasted');
    },

    parseCSVData: function(content, source) {
      const lines = content.split(/\r?\n/).filter(line => line.trim());
      const parsedData = [];
      const errors = [];

      if (lines.length === 0) {
        this.showError('No data found. Please paste or upload valid CSV/TSV data.');
        return;
      }

      // Detect delimiter (comma or tab)
      const firstLine = lines[0] || '';
      const delimiter = firstLine.includes('\t') ? '\t' : ',';

      // Check if first line is a header
      let startIndex = 0;
      if (firstLine.toLowerCase().includes('name') || firstLine.match(/^name[,\t]/i)) {
        console.log('Detected header row, skipping it');
        startIndex = 1;
      }

      lines.forEach((line, lineNumber) => {
        // Skip header row if detected
        if (lineNumber < startIndex) return;

        const parts = this.parseCSVLine(line, delimiter);
        const displayLineNumber = lineNumber + 1;

        // Check for empty line
        if (parts.length === 1 && !parts[0].trim()) {
          return; // Skip empty lines silently
        }

        // Validate minimum columns
        if (parts.length < 2) {
          errors.push(`Line ${displayLineNumber}: Not enough columns. Expected at least 2 columns (name, character), found ${parts.length}.`);
          return;
        }

        const name = parts[0].trim();
        const character = parts[1] ? parts[1].trim() : '';

        // Validate name
        if (!name) {
          errors.push(`Line ${displayLineNumber}: Name is required but was empty.`);
          return;
        }

        // New format: name, character, director(x), producer(x), writer(x), actor(x)
        // Old format: name, character, roles (for backwards compatibility)
        let roles = [];

        if (parts.length === 2) {
          // Old format: name, roles (no character)
          const rolesString = parts[1].trim().toLowerCase();
          roles = rolesString.split('/').map(r => r.trim()).filter(r => r);
        } else if (parts.length === 3) {
          // Old format: name, character, roles
          const rolesString = parts[2].trim().toLowerCase();
          roles = rolesString.split('/').map(r => r.trim()).filter(r => r);
        } else if (parts.length >= 6) {
          // New format: check each role column
          const roleColumns = {
            director: parts[2] ? parts[2].trim().toLowerCase() : '',
            producer: parts[3] ? parts[3].trim().toLowerCase() : '',
            writer: parts[4] ? parts[4].trim().toLowerCase() : '',
            actor: parts[5] ? parts[5].trim().toLowerCase() : '',
          };

          // Check each role column for 'x' or '1' or 'yes' or 'true'
          Object.entries(roleColumns).forEach(([role, value]) => {
            if (value && (value === 'x' || value === '1' || value === 'yes' || value === 'true' || value === role)) {
              roles.push(role);
            }
          });
        } else if (parts.length === 4 || parts.length === 5) {
          // Invalid format - not old format (2-3 columns) and not new format (6+ columns)
          errors.push(`Line ${displayLineNumber}: Invalid format. Expected 2-3 columns (old format) or 6 columns (new format), found ${parts.length}.`);
          return;
        }

        // Validate roles
        const validRoles = roles.filter(role => this.config.reverseRoleMap[role]);
        const invalidRoles = roles.filter(role => !this.config.reverseRoleMap[role]);

        if (invalidRoles.length > 0) {
          errors.push(`Line ${displayLineNumber}: Invalid role(s): ${invalidRoles.join(', ')}. Valid roles are: actor, director, producer, writer.`);
        }

        if (validRoles.length === 0) {
          errors.push(`Line ${displayLineNumber}: No valid roles found for "${name}". At least one role is required.`);
          return;
        }

        parsedData.push({
          name,
          roles: validRoles,
          character,
          index: lineNumber,
        });
      });

      // Show errors if any
      if (errors.length > 0) {
        const errorMessage = `Found ${errors.length} error(s) in the data:\n\n` + errors.slice(0, 5).join('\n');
        const additionalErrors = errors.length > 5 ? `\n\n...and ${errors.length - 5} more errors.` : '';
        this.showError(errorMessage + additionalErrors);
        return;
      }

      if (parsedData.length === 0) {
        this.showError('No valid data found. Please check the format and ensure each row has a name and at least one valid role.');
        return;
      }

      // Store for import
      this.config.pendingCSVData = parsedData;

      // Show preview
      this.displayCSVPreview(parsedData);
    },

    parseCSVLine: function(line, delimiter) {
      const parts = [];
      let current = '';
      let inQuotes = false;

      for (let i = 0; i < line.length; i++) {
        const char = line[i];

        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === delimiter && !inQuotes) {
          parts.push(current);
          current = '';
        } else {
          current += char;
        }
      }

      parts.push(current);
      return parts;
    },

    displayCSVPreview: function(data) {
      this.config.pendingCSVData = data;

      // Same empty-guard as the IMDB path: bulk-suggest 422s on empty arrays,
      // and a CSV that parsed to zero rows should show a clear message rather
      // than the generic "Invalid request format" from the backend.
      if (!Array.isArray(data) || data.length === 0) {
        $('#csv-preview .preview-table-container').html(`
          <div class="empty-state" style="padding: 24px; text-align: center; color: #666;">
            <i class="fas fa-info-circle" style="font-size: 24px; opacity: .6;"></i>
            <p style="margin: 10px 0 4px; font-weight: 600;">No people found in the CSV.</p>
            <p style="margin: 0; font-size: 13px;">Check that the file has a header row and at least one data row.</p>
          </div>
        `);
        $('#csv-preview').show();
        $('.tab-content').hide();
        return;
      }

      // Show loading indicator
      $('#csv-preview .preview-table-container').html(`
        <div class="matching-contacts-loading">
          <i class="fas fa-spinner fa-spin"></i> Matching contacts with existing database...
        </div>
      `);
      $('#csv-preview').show();
      $('.tab-content').hide();

      // Prepare bulk search data
      const searchQueries = data.map(person => ({
        name: person.name,
        imdb_id: null, // CSV doesn't have IMDB IDs
      }));

      // Use bulk API call for contact matching
      this.apiRequest('POST', 'contacts/bulk-suggest', { queries: searchQueries })
        .then(result => {
          if (result.success && result.data) {
            // Map bulk results back to people
            data.forEach((person, index) => {
              const matches = result.data[index] || [];
              if (matches.length > 0) {
                // Store all matches
                person.allMatches = matches;

                // Look for all exact name matches
                const exactNameMatches = matches.filter(contact =>
                  contact.name.toLowerCase() === person.name.toLowerCase(),
                );

                // Look for all IMDB matches (if person has IMDB ID)
                const imdbMatches = person.imdbId ?
                  matches.filter(contact => contact.imdb_id === person.imdbId) : [];

                // Determine which set of matches to use
                let relevantMatches = [];
                if (exactNameMatches.length > 0) {
                  relevantMatches = exactNameMatches;
                } else if (imdbMatches.length > 0) {
                  relevantMatches = imdbMatches;
                } else if (matches.length === 1) {
                  relevantMatches = matches;
                }

                if (relevantMatches.length > 1) {
                  // Multiple exact matches - show radio list
                  person.multipleMatches = true;
                  person.allMatches = relevantMatches;

                  // Sort by ID and select the one with lowest ID as default
                  relevantMatches.sort((a, b) => a.id - b.id);
                  person.matchedContact = relevantMatches[0];
                  person.matched_contact_id = relevantMatches[0].id;
                  person.matched_avatar = relevantMatches[0].avatar;
                  person.matched_imdb_id = relevantMatches[0].imdb_id;
                } else if (relevantMatches.length === 1) {
                  // Single match
                  person.matchedContact = relevantMatches[0];
                  person.matched_contact_id = relevantMatches[0].id;
                  person.matched_avatar = relevantMatches[0].avatar;
                  person.matched_imdb_id = relevantMatches[0].imdb_id;
                } else if (matches.length > 0) {
                  // No exact matches but have other matches - show first as suggestion
                  person.matchedContact = matches[0];
                  person.matched_contact_id = matches[0].id;
                  person.matched_avatar = matches[0].avatar;
                  person.matched_imdb_id = matches[0].imdb_id;
                }
              }
            });
          }
        })
        .catch(error => {
          console.error('Bulk contact matching failed:', error);
          // Fallback to individual requests if bulk fails
          const checkPromises = data.map(person => {
            return this.apiRequest('GET', `contacts/suggest?q=${encodeURIComponent(person.name)}&limit=5`)
              .then(result => {
                if (result.success && result.data && result.data.length > 0) {
                  const exactMatch = result.data.find(contact =>
                    contact.name.toLowerCase() === person.name.toLowerCase(),
                  );

                  if (exactMatch) {
                    person.matchedContact = exactMatch;
                    person.matched_contact_id = exactMatch.id;
                    person.matched_avatar = exactMatch.avatar;
                    person.matched_imdb_id = exactMatch.imdb_id;
                  }
                }
                return person;
              })
              .catch(() => person);
          });
          return Promise.all(checkPromises);
        })
        .then(() => {
          // Use unified preview table component
          ImportPreviewTable.render({
            data: this.config.pendingCSVData,
            type: 'csv',
            container: '#csv-preview .preview-table-container',
            existingData: this.config.data,
            canEditContact: window.sflow?.permissions?.can_edit_contact || false,
            reverseRoleMap: this.config.reverseRoleMap,
          });

          $('#csv-preview').show();
          $('.tab-content').hide();

          // Apply initial filters
          this.applyInitialImportFilters('csv');
        });
    },

    downloadSampleCSV: function() {
      // Create sample CSV content with new format
      const csvContent = `Name,Character,Director,Producer,Writer,Actor
Robert Downey Jr.,Tony Stark / Iron Man,,,,x
Christopher Nolan,,x,,x,
Kevin Feige,,,x,,
Scarlett Johansson,Natasha Romanoff / Black Widow,,,,x
Jon Favreau,Happy Hogan,x,x,,x
Stan Lee,Cameo,,,,x
Alan Silvestri,,,,,
Victoria Alonso,,,x,,
Louis D'Esposito,,,x,,
Joss Whedon,,x,,x,`;

      // Create blob and download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      link.setAttribute('href', url);
      link.setAttribute('download', 'cast-crew-sample.csv');
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    },

    resetCSVImport: function() {
      $('#csv-preview').hide();
      $('.tab-content').hide();

      // Remember which tab was active
      const activeTab = $('.tab-button.active').data('tab') || 'upload';

      // Show the previously active tab
      $(`#${activeTab}-tab`).show();

      // Clear inputs
      $('#csv-file').val('');
      $('#csv-paste-area').val('');
      this.config.pendingCSVData = null;

      // Maintain tab state (don't reset it)
      // The active tab button stays as it was
    },

    performCSVImport: function() {
      if (!this.config.pendingCSVData || this.config.pendingCSVData.length === 0) {
        this.showError('No CSV data to import');
        return;
      }

      // Get selected indices
      const selectedIndices = [];
      $('.import-select-csv:checked').each(function() {
        selectedIndices.push(parseInt($(this).data('index')));
      });

      if (selectedIndices.length === 0) {
        this.showError('Please select at least one person to import');
        return;
      }

      const addedIds = [];
      const newPeopleToAdd = [];

      // Process selected people in order
      selectedIndices.forEach(index => {
        const person = this.config.pendingCSVData[index];
        const existingPerson = this.findExistingPerson(person.name);

        if (existingPerson) {
          // Update existing person
          const roleIds = person.roles.map(role => this.config.reverseRoleMap[role]);
          existingPerson.contact_types = roleIds;
          if (person.roles.includes('actor') && person.character) {
            existingPerson.contact_character_name = person.character;
          }
          // Clear deleted flag if it was set (in case of Replace All)
          if (existingPerson.deleted) {
            existingPerson.deleted = false;
          }
          this.config.unsavedChanges.add(existingPerson.title_contact_id);
        } else {
          // Add new person - collect them first to maintain order
          const newId = 'new_csv_' + Date.now() + '_' + person.index;
          const roleIds = person.roles.map(role => this.config.reverseRoleMap[role]);

          const newPerson = {
            title_contact_id: newId,
            // Use matched contact's name if available, otherwise use imported name
            name: person.matchedContact ? person.matchedContact.name : person.name,
            contact_character_name: person.character || '',
            contact_types: roleIds,
            display_order: 0, // Will be updated after insertion
            id: person.matched_contact_id || null,
            isNew: true,
            // Include matched contact info if available
            matched: person.matchedContact ? true : false,
            contact_id: person.matched_contact_id || null,
            c_avatar: person.matched_avatar || null,
            c_imdb_id: person.matched_imdb_id || null,
            importOrder: index, // Preserve import order
          };

          newPeopleToAdd.push(newPerson);
          this.config.unsavedChanges.add(newId);
          addedIds.push(newId);
        }
      });

      // Add new people at the beginning, preserving their order
      if (newPeopleToAdd.length > 0) {
        // Sort by import order to maintain preview order
        newPeopleToAdd.sort((a, b) => a.importOrder - b.importOrder);

        // Insert at beginning of arrays
        this.config.data.unshift(...newPeopleToAdd);
        this.config.filteredData.unshift(...newPeopleToAdd);

        // Update display orders for all items
        this.config.data.forEach((item, index) => {
          item.display_order = index;
          if (newPeopleToAdd.includes(item) || this.config.unsavedChanges.has(item.title_contact_id)) {
            this.config.unsavedChanges.add(item.title_contact_id);
          }
        });
      }

      // Re-render list
      this.renderList();
      this.updateSaveButton();
      this.updateIndicators();

      // Close modal
      $('#import-modal').foundation('close');

      // Show success message
      this.showSuccess(`Successfully imported ${this.config.pendingCSVData.length} entries`);

      // Clean up
      this.config.pendingCSVData = null;
    },

    performIMDBImport: function() {
      if (!this.config.pendingIMDBData || this.config.pendingIMDBData.length === 0) {
        this.showError('No IMDB data to import');
        return;
      }

      // Get selected indices
      const selectedIndices = [];
      $('.import-select-imdb:checked').each(function() {
        selectedIndices.push(parseInt($(this).data('index')));
      });

      if (selectedIndices.length === 0) {
        this.showError('Please select at least one person to import');
        return;
      }

      // Process selected people
      const addedIds = [];
      const updatedIds = [];
      const newPeopleToAdd = [];

      selectedIndices.forEach(index => {
        const imdbPerson = this.config.pendingIMDBData[index];

        // Try to find existing person by name
        let existingPerson = this.findExistingPerson(imdbPerson.name);

        if (existingPerson) {
          // Update existing person
          const roleIds = imdbPerson.roles.map(role => this.config.reverseRoleMap[role]).filter(Boolean);

          existingPerson.contact_types = roleIds;
          if (imdbPerson.roles.includes('actor') && imdbPerson.character) {
            existingPerson.contact_character_name = imdbPerson.character;
          }

          // Clear deleted flag if it was set (in case of Replace All)
          if (existingPerson.deleted) {
            existingPerson.deleted = false;
          }

          // Set IMDB ID if available
          if (imdbPerson.imdbId) {
            existingPerson.c_imdb_id = imdbPerson.imdbId;
          }

          // Set IMDB URL if available
          if (imdbPerson.imdbUrl) {
            existingPerson.c_imdb = imdbPerson.imdbUrl;
          }

          // Update avatar if available
          if (imdbPerson.image) {
            existingPerson.c_avatar = imdbPerson.image;
          }

          this.config.unsavedChanges.add(existingPerson.title_contact_id);
          updatedIds.push(existingPerson.title_contact_id);
        } else {
          // Add new person - collect them first to maintain order
          const newId = 'new_imdb_' + Date.now() + '_' + index;
          const roleIds = imdbPerson.roles.map(role => this.config.reverseRoleMap[role]).filter(Boolean);

          const newPerson = {
            title_contact_id: newId,
            // Use matched contact's name if available, otherwise use imported name
            name: imdbPerson.matchedContact ? imdbPerson.matchedContact.name : imdbPerson.name,
            contact_character_name: imdbPerson.character || '',
            contact_types: roleIds,
            display_order: 0, // Will be updated after insertion
            id: imdbPerson.matched_contact_id || null,
            isNew: true,
            matched: imdbPerson.matchedContact ? true : false,
            contact_id: imdbPerson.matched_contact_id || null,
            c_imdb_id: imdbPerson.matched_imdb_id || imdbPerson.imdbId || null,
            c_imdb: imdbPerson.imdbUrl || null, // IMDB profile URL
            c_avatar: imdbPerson.matched_avatar || imdbPerson.image || null,
            importOrder: imdbPerson.orderIndex !== undefined ? imdbPerson.orderIndex : index, // Use orderIndex from IMDB data
          };

          newPeopleToAdd.push(newPerson);
          this.config.unsavedChanges.add(newId);
          addedIds.push(newId);
        }
      });

      // Add new people at the beginning, preserving their order
      if (newPeopleToAdd.length > 0) {
        // Sort by import order to maintain IMDB order
        newPeopleToAdd.sort((a, b) => a.importOrder - b.importOrder);

        // Insert at beginning of arrays
        this.config.data.unshift(...newPeopleToAdd);
        this.config.filteredData.unshift(...newPeopleToAdd);

        // Update display orders for all items
        this.config.data.forEach((item, index) => {
          item.display_order = index;
          if (newPeopleToAdd.includes(item) || this.config.unsavedChanges.has(item.title_contact_id)) {
            this.config.unsavedChanges.add(item.title_contact_id);
          }
        });
      }

      // Re-render list
      this.renderList();
      this.updateSaveButton();
      this.updateIndicators();

      // Apply visual indicators
      setTimeout(() => {
        addedIds.forEach(id => {
          $(`.person-component[data-id="${id}"]`).addClass('newly-added');
        });
        updatedIds.forEach(id => {
          $(`.person-component[data-id="${id}"]`).addClass('recently-updated');
        });
      }, 100);

      // Close modal
      $('#import-modal').foundation('close');

      // Show success message
      const message = `Imported ${addedIds.length} new and updated ${updatedIds.length} existing cast/crew members`;
      this.showSuccess(message);
    },
  };

  // Initialize when ready
  $(document).ready(function() {
    if ($('.cast-crew-container').length > 0 || $('.cast-crew-editor-container').length > 0) {
      CastCrewComponents.init();
    }
  });

  // Export to global scope
  window.CastCrewComponents = CastCrewComponents;

})(jQuery);
